
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/mousewheel.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-graph-mousewheel-demo-api-graph-mousewheel"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/mousewheel.en.md?type=demo')
};